import React from 'react';
import { useSelector } from 'react-redux';
import {
    selectDetailsChain,
    selectDetailsLoadingContact,
    closeContactDetails,
    selectDetailsIndex,
    backInDetailsChain,
    selectDetailsRefreshing,
} from '../stores/contacts-slice-handler';
import SimpleModal from '../../shared/components/simple-modal';
import Preloader from '../../shared/components/preloader';
import t from '../../../utils/translate';
import ContactDetailsUser from './contact-details-user';
import ContactDetailsGroup from './contact-details-group';

export default function ContactDetailsManager() {
    const detailsChain = useSelector(selectDetailsChain);
    const detailsIndex = useSelector(selectDetailsIndex);
    const detailsRefreshing = useSelector(selectDetailsRefreshing);
    const detailsLoadingContact = useSelector(selectDetailsLoadingContact);

    if (detailsChain.length === 0 && detailsLoadingContact === null) {
        return '';
    }

    const contact = detailsChain[detailsIndex] || null;

    const renderTitle = () => {
        const titleText = contact
            ? contact.IsGroup
                ? t('js_all_option_group_details')
                : t('js_all_option_user_details')
            : t('js_all_popup_details');

        if (detailsIndex === 0) {
            return titleText;
        }

        return (
            <div className="contact-details-title">
                <div className="back-button" data-test-id="back-button" onClick={() => backInDetailsChain()}>
                    <span className="stw-left-chevron"></span>
                </div>
                <div className="title-text">{titleText}</div>
            </div>
        );
    };

    return (
        <>
            <SimpleModal open={true} closeCallback={() => closeContactDetails()} dialogTitle={renderTitle()}>
                <div className="wcfui-contact-details-modal">
                    {(detailsLoadingContact || detailsRefreshing) && <Preloader asOverlay></Preloader>}
                    {contact && (
                        <>
                            {contact.IsGroup ? (
                                <ContactDetailsGroup groupId={contact.GroupId} />
                            ) : (
                                <ContactDetailsUser msisdn={contact.Msisdn} />
                            )}
                        </>
                    )}
                </div>
            </SimpleModal>
        </>
    );
}
